import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {SessionActions} from "../../../shared/actions/session.actions";
import {MedicineStickersService, StickerFormatsResult} from "../../services/medicine-stickers.service";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {StickerSheet} from "../../../shared/view-model/store-management/sticker-sheet.type";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {StickerFormat} from "../../../shared/view-model/store-management/sticker-format.type";
import {FormBuilder, FormGroup} from "@angular/forms";
import {StickerFormatFormComponent} from "../sticker-format-form/sticker-format-form.component";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {MessageType} from "../../../shared/redux-store/session";

@Component({
  selector: 'vb-sticker-formats-table',
  templateUrl: './sticker-formats-table.component.html',
  styleUrls: ['./sticker-formats-table.component.css']
})
export class StickerFormatsTableComponent extends AbstractListView implements OnInit {

  @ViewChild('stickerFormatsTable')
  table: DatatableComponent;

  @ViewChild('editStickerFormatModal')
  editStickerFormatModal: GenericModalComponent;

  messages = {
    emptyMessage: 'Keine Beschriftungsformate vorhanden',
    totalMessage: 'Beschriftungsformate auf der Liste'
  };

  private stickerFormats$: ApolloQueryObservable<StickerFormatsResult>;
  stickerFormats: StickerSheet[];

  currentStickerFormat: StickerFormat;
  currentStickerFormatControl: FormGroup;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private medStickersService: MedicineStickersService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.isLoading = true;

    this.stickerFormats$ = this.medStickersService.getStickerFormats();
    this.addComponentData(this.stickerFormats$);

    this.dataSubscriptions.push(
      this.stickerFormats$.subscribe(res => {
        this.stickerFormats = res.data.stickerFormats;
        this.isLoading = res.loading;
        this.rows = this.stickerFormats;
      })
    );

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'label', name: 'Bezeichner', minWidth: 100, flexGrow: 2},
      {prop: 'created_at', name: 'Erstelldatum', cellTemplate: this.table.formatDateTmpl},
      {prop: 'administration_unit.label', name: 'Verwaltungseinheit', minWidth: 100, flexGrow: 2},
    ];

  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.stickerFormats;
    } else {
      if (this.stickerFormats) {
        this.rows = this.stickerFormats.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onDeleteStickerFormatClicked(stickerFormatCuid: string) {
    this.medStickersService.deleteStickerFormat(stickerFormatCuid).subscribe(
      res => this.sessionActions.pushMessage("Beschriftungsformat erfolgreich gelöscht!", MessageType.SUCCESS, "Beschriftungsformat"),
      err => this.sessionActions.throwError(err, "Fehler beim Löschen des Beschriftungsformats!")
    );
  }

  onEditStickerFormatClicked(stickerFormat: StickerFormat) {
    this.currentStickerFormatControl = StickerFormatFormComponent.initControl(this.fb);
    this.currentStickerFormat = stickerFormat;
    this.editStickerFormatModal.show();
  }

  updateStickerFormatClicked() {
    let obs = this.medStickersService.updateStickerFormat(this.currentStickerFormat.cuid, this.currentStickerFormatControl.value);
    obs.subscribe(
      res => {
        this.sessionActions.pushMessage("Änderungen erfolgreich gespeichert!", MessageType.SUCCESS, "Beschriftungsformat");
        this.cancelUpdate();
      },
      err => this.sessionActions.throwError(err, "Fehler beim Speichern der Änderungen!")
    );
  }

  cancelUpdate() {
    this.currentStickerFormat = null;
    this.currentStickerFormatControl = null;
  }

}


// WEBPACK FOOTER //
// ./src/app/medicine-stickers/components/sticker-formats-table/sticker-formats-table.component.ts